import React from 'react';
import { RidehailsProvider } from '@hopdrive/feature-ridehails';
import { DealerRidehailsHost } from '../host';
import RideSharesTabQuery from './RideSharesTabQuery';

// COMPONENT ---------------------------------------------------------------- //

/** Valet's Rideshares tab: the rideshares view inside the product shell, with the header carrying its actions. */
const RideSharesTab: React.FC = () => {
  return (
    <DealerRidehailsHost>
      <RidehailsProvider>
        <RideSharesTabQuery />
      </RidehailsProvider>
    </DealerRidehailsHost>
  );
};

// EXPORT ---------------------------------------------------------------- //

export default RideSharesTab;